<template>
  <div class="rule-wrapper">
    <h2>CRIAR NOVA REGRA:</h2>

    <div class="form-grid">
      <div class="form-group">
        <label>Comissão <span class="message">*</span></label>
        <input-percent
          class="form-control"
          v-model="newRuleForm.percComissao"
        />
      </div>

      <div class="form-group">
        <label>Qtd. Min</label>
        <input
          class="form-control"
          v-model.number="newRuleForm.qtdMinima"
          type="number"
        />
      </div>

      <div class="form-group">
        <label>Qtd. Máx</label>
        <input
          class="form-control"
          v-model.number="newRuleForm.qtdMaxima"
          type="number"
        />
      </div>

      <div class="form-group">
        <label>Perc. Min Desc</label>
        <input-percent class="form-control" v-model="newRuleForm.percMinDesc" />
      </div>

      <div class="form-group">
        <label>Perc. Máx Desc</label>
        <input-percent class="form-control" v-model="newRuleForm.percMaxDesc" />
      </div>

      <div class="form-group btn-wrapper">
        <button
          class="button button-primary"
          title="Adicionar"
          :disabled="isAddButtonDisabled"
          @click="addRule()"
        >
          +
        </button>
      </div>
    </div>

    <div class="xrow" style="margin-top: 24px">
      <h2>REGRAS CADASTRADAS:</h2>

      <div class="table-responsive" v-if="sortedRegras.length">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Comissão (%)</th>
              <th>Qtd. Min</th>
              <th>Qtd. Máx</th>
              <th>% Desc. Min</th>
              <th>% Desc. Máx</th>
              <th>Ação</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(regra, index) in sortedRegras" :key="index">
              <!-- MODO EDIÇÃO -->
              <template v-if="editingIndex === index">
                <td>
                  <input-percent
                    class="form-control"
                    v-model="editRule.percComissao"
                  />
                </td>

                <td>
                  <input
                    type="number"
                    v-model.number="editRule.qtdMinima"
                    class="form-control"
                  />
                </td>

                <td>
                  <input
                    type="number"
                    v-model.number="editRule.qtdMaxima"
                    class="form-control"
                  />
                </td>

                <td>
                  <input-percent
                    class="form-control"
                    v-model="editRule.percMinDesc"
                  />
                </td>

                <td>
                  <input-percent
                    class="form-control"
                    v-model="editRule.percMaxDesc"
                  />
                </td>

                <td>
                  <div class="edit-actions">
                    <button
                      class="button button-success"
                      @click="saveEdit(index)"
                    >
                      Salvar
                    </button>
                    <button class="button button-warning" @click="cancelEdit">
                      Cancelar
                    </button>
                  </div>
                </td>
              </template>

              <!-- MODO NORMAL -->
              <template v-else>
                <td>{{ formatPercent(regra.percComissao) }}</td>
                <td>{{ regra.qtdMinima ?? "-" }}</td>
                <td>{{ regra.qtdMaxima ?? "-" }}</td>
                <td>{{ formatPercent(regra.percMinDesc) }}</td>
                <td>{{ formatPercent(regra.percMaxDesc) }}</td>

                <td>
                  <div class="edit-actions">
                    <button
                      class="button button-primary"
                      @click="startEdit(index)"
                    >
                      <fa-icon icon="pencil-alt" />
                    </button>
                    <button
                      class="button button-error"
                      @click="removeRule(index)"
                    >
                      <strong>&times;</strong>
                    </button>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else>
        <em>Nenhuma regra cadastrada ainda.</em>
      </div>
    </div>
  </div>
</template>

<script>
const initialRuleForm = () => ({
  percComissao: 0,
  percMinDesc: 0,
  percMaxDesc: 0,
  qtdMinima: null,
  qtdMaxima: null,
});

export default {
  name: "RangesComissao",
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return {
      newRuleForm: initialRuleForm(),
      editingIndex: null,
      editRule: null,
    };
  },

  computed: {
    // só permite adicionar se comissão for > 0
    isAddButtonDisabled() {
      return !this.newRuleForm.percComissao;
    },

    // tabela SEMPRE ordenada
    sortedRegras() {
      return [...this.form.regras].sort(
        (a, b) => a.percComissao - b.percComissao
      );
    },
  },

  methods: {
    addRule() {
      const clone = JSON.parse(JSON.stringify(this.newRuleForm));
      this.form.regras.push(clone);
      this.resetRuleForm();
    },

    resetRuleForm() {
      Object.assign(this.newRuleForm, initialRuleForm());
    },

    removeRule(index) {
      this.form.regras.splice(index, 1);
    },

    formatPercent(value) {
      if (value == null) {
        return "-";
      }
      return `${Number(value).toFixed(2)}%`;
    },
    startEdit(index) {
      this.editingIndex = index;
      this.editRule = JSON.parse(JSON.stringify(this.sortedRegras[index]));
    },

    cancelEdit() {
      this.editingIndex = null;
      this.editRule = null;
    },

    saveEdit(index) {
      if (!this.editRule.percComissao) {
        return;
      }
      Object.assign(this.form.regras[index], this.editRule);
      this.cancelEdit();
    },
  },
};
</script>

<style scoped>
.rule-wrapper {
  width: 100%;
  margin-top: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px; /* mais espaço */
  align-items: flex-start; /* botão não fica “grudado” no label */
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  display: block;
}

.btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
}

.button {
  padding: 8px 12px;
}

.table-responsive {
  margin-top: 16px;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table th {
  font-weight: 600;
}

.table th,
.table td {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.edit-actions {
  display: flex;
  gap: 4px;
}
</style>
